const occasionBirthdays = require('./imgs/occasion-birthdays.png');
const occasionAnniversaries = require('./imgs/occasion-anniversaries.png');
const occasionValentines = require('./imgs/occasion-valentines.png');
const occasionThankYous = require('./imgs/occasion-thank-yous.png');
const occasionCarePackage = require('./imgs/occasion-care-package.png');
const occasionBackToSchool = require('./imgs/occasion-back-to-school.png');

/** Default copy, CTA, and occasion cards; override via props when CMS is wired. */
export const GIFTING_OCCASIONS_MOBILE_LAYOUT_MAX_WIDTH = 991;

export const GIFTING_OCCASIONS_HEADLINE_LINES_MOBILE = [
  'Something ',
  'sweet for every occasion',
];

export const GIFTING_OCCASIONS_DEFAULT = {
  headlineLines: ['Something ', 'sweet ', 'for every ', 'occasion'],
  ctaText: 'Shop the Menu',
  ctaLink: '/menu',
  ctaButtonType: 'internal_link',
  contentSection: 'Gifting LP — Occasions',
  cards: [
    {
      id: 'birthdays',
      title: 'Birthdays',
      description: 'Better than another candle',
      imageSrc: occasionBirthdays,
      imageAlt: 'Birthday cookie gift',
    },
    {
      id: 'anniversaries',
      title: 'Anniversaries',
      description: 'Celebrate another year together',
      imageSrc: occasionAnniversaries,
      imageAlt: 'Anniversary cookie gift',
    },
    {
      id: 'valentines',
      title: "Valentine's Day",
      description: 'Made special for your favorite person',
      imageSrc: occasionValentines,
      imageAlt: "Valentine's Day cookie gift",
    },
    {
      id: 'thank-yous',
      title: "Thank you's",
      description: 'A sweeter way to say thanks',
      imageSrc: occasionThankYous,
      imageAlt: 'Thank you cookie gift',
    },
    {
      id: 'care-package',
      title: 'Care package',
      description: 'Graduation, holidays, send a little love',
      imageSrc: occasionCarePackage,
      imageAlt: 'Care package cookie gift',
    },
    {
      id: 'back-to-school',
      title: 'Back to school',
      description: 'Start the year off on a sweet note',
      imageSrc: occasionBackToSchool,
      imageAlt: 'Back to school cookie gift',
    },
  ],
};
